import { useState, useMemo, memo } from 'react';
import EcoSpace from 'eco-design/base/eco-space';
import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';
import { useLang } from '@/i18n';

interface ItemType {
    name: string | React.ReactNode;
    text?: string;
    img: string[];
}

const SectionD: React.FC = () => {
    const { t } = useLang('theProduct.SectionD');
    const [enter] = useState(false);

    const items: ItemType[] = useMemo(
        () => [
            {
                name: t.rich('item1_title', {
                    bold: (v: string) => <span className="bold-text">{v}</span>,
                }),
                text: t('item1_desc'),
                img: [
                    'https://websiteoss.ecoflow.com/upload/image/1761556641516/sectionc_info_1.jpg',
                    'https://websiteoss.ecoflow.com/upload/image/1761721101591/sectiond_1_pad.jpg',
                    'https://websiteoss.ecoflow.com/upload/image/1761557130885/sectiond_1_h5.jpg',
                ],
            },
            {
                name: t('item2_title'),
                text: t('item2_desc'),
                img: [
                    'https://websiteoss.ecoflow.com/upload/image/1761556642936/sectionc_info_2.jpg',
                    'https://websiteoss.ecoflow.com/upload/image/1761721102023/sectiond_2_pad.jpg',
                    'https://websiteoss.ecoflow.com/upload/image/1761557129077/sectiond_2_h5.jpg',
                ],
            },
            {
                name: t('item3_title'),
                img: [
                    'https://websiteoss.ecoflow.com/upload/image/1761556641977/sectionc_info_3.jpg',
                    'https://websiteoss.ecoflow.com/upload/image/1761721101887/sectiond_3_pad.jpg',
                    'https://websiteoss.ecoflow.com/upload/image/1761557130467/sectiond_3_h5.jpg',
                ],
            },
            {
                name: t('item4_title'),
                text: t('item4_desc'),
                img: [
                    'https://websiteoss.ecoflow.com/upload/image/1761556642665/sectionc_info_4.jpg',
                    'https://websiteoss.ecoflow.com/upload/image/1761721101679/sectiond_4_pad.jpg',
                    'https://websiteoss.ecoflow.com/upload/image/1761557131184/sectiond_4_h5.jpg',
                ],
            },
            {
                name: t.rich('item5_title', {
                    highlight: (v: string) => <span className="highlight-text">{v}</span>,
                }),
                img: [
                    'https://websiteoss.ecoflow.com/upload/image/1761556642185/sectionc_info_5.jpg',
                    'https://websiteoss.ecoflow.com/upload/image/1761721101715/sectiond_5_pad.jpg',
                    'https://websiteoss.ecoflow.com/upload/image/1761557130167/sectiond_5_h5.jpg',
                ],
            },
            {
                name: t('item6_title'),
                text: t('item6_desc'),
                img: [
                    'https://websiteoss.ecoflow.com/upload/image/1761556642380/sectionc_info_6.jpg',
                    'https://websiteoss.ecoflow.com/upload/image/1761721101745/sectiond_6_pad.jpg',
                    'https://websiteoss.ecoflow.com/upload/image/1761557129348/sectiond_6_h5.jpg',
                ],
            },
            {
                name: t('item7_title'),
                // text: t('item7_desc'),
                img: [
                    'https://websiteoss.ecoflow.com/upload/image/1761556641661/sectionc_info_7.jpg',
                    'https://websiteoss.ecoflow.com/upload/image/1761721102022/sectiond_7_pad.jpg',
                    'https://websiteoss.ecoflow.com/upload/image/1761557129755/sectiond_7_h5.jpg',
                ],
            },
        ],
        [t],
    );

    return (
        <section className={`${css.SectionD} GtmModuleData-section eco-content`} data-section-id={'on-the-road-SectionD'}>
            <EcoSpace />

            <div className={`items ${enter ? 'enter' : ''}`}>
                {items.map((item: ItemType, k: number) => (
                    <div key={item.name} className={`item item-${k + 1}`} style={{ gridArea: `g${k + 1}` }}>
                        <div className="item-card">
                            <div className="item-img-box">
                                <EcoImg className="item-img" pc={item.img[0]} pad={item.img[1]} h5={item.img[2]} isOpenLazy />
                            </div>
                            <div className="item-info">
                                <p className="item-name">{item.name}</p>
                                <div className="item-info-img">
                                    <EcoImg
                                        pc="https://websiteoss.ecoflow.com/upload/image/1761623987144/sectiond_info.png"
                                        h5="https://websiteoss.ecoflow.com/upload/image/1761623987144/sectiond_info.png"
                                        isOpenLazy
                                    />
                                </div>
                                {item?.text && <p className="item-text">{item.text}</p>}
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div className="footer-info">
                <p className="footer-info-text">{t('footer_info_1')}</p>
                <p className="footer-info-text">{t('footer_info_2')}</p>
            </div>
        </section>
    );
};

export default memo(SectionD);
